import React, { useState } from "react";
import "./StickyContactForm.css";

const StickyContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    propertyType: "",
  });

  const [status, setStatus] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);

  // Use your current Apps Script URL
  const GOOGLE_APPS_SCRIPT_URL =
    "https://script.google.com/macros/s/AKfycbw684Jt0054pXYuTjq_ogp08tGO1dTQE17hDGeRdul0tMglpMTlLjQv_VHQP_yZmHqH/exec";

  const propertyTypes = [
    "Ground Floor + Basement",
    "First Floor",
    "Second Floor + Terraces",
    "Any Available Floor",
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "", message: "" });

    try {
      const body = new URLSearchParams({
        name: formData.name,
        email: formData.email,
        mobile: formData.mobile,
        propertyType: formData.propertyType || "",
        propertyName: "Ansal Esencia",
        pageurl: window.location.href,
        source: "Website Contact Form",
      });

      const res = await fetch(GOOGLE_APPS_SCRIPT_URL, {
        method: "POST",
        // Do NOT set Content-Type; the browser will set application/x-www-form-urlencoded;charset=UTF-8
        body,
      });

      const text = await res.text();
      let result;
      try {
        result = JSON.parse(text);
      } catch {
        result = { status: "error", message: "Invalid server response." };
      }

      if (result.status === "success") {
        setStatus({
          type: "success",
          message:
            "Thank you! Your inquiry has been submitted successfully. We will contact you soon.",
        });
        setFormData({ name: "", email: "", mobile: "", propertyType: "" });
      } else {
        setStatus({
          type: "error",
          message: result.message || "Submission failed. Please try again.",
        });
      }
    } catch (err) {
      setStatus({
        type: "error",
        message:
          "Failed to submit form. Please try again or contact us directly at +91 9999063322.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleWhatsAppClick = () => {
    const message = `Hi, I'm interested in Ansal Esencia Sovereign Floors. Please provide more details.

Name: ${formData.name || "Not provided"}
Email: ${formData.email || "Not provided"}
Mobile: ${formData.mobile || "Not provided"}
Property Type: ${formData.propertyType || "Any Available Floor"}`;

    const whatsappUrl = `https://wa.me/919999063322?text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <div className="sticky-form-container">
      <div className="sticky-form">
        <div className="form-header">
          <h3 className="form-title">Yes I'm Interested</h3>
        </div>

        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>

          <div className="form-group">
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>

          <div className="form-group">
            <input
              type="tel"
              name="mobile"
              placeholder="Mobile"
              value={formData.mobile}
              onChange={handleChange}
              className="form-control"
              required
              pattern="[0-9]{10}"
              maxLength="10"
            />
          </div>

          <div className="form-group">
            <select
              name="propertyType"
              value={formData.propertyType}
              onChange={handleChange}
              className="form-control"
            >
              <option value="">Please Select Property Type</option>
              {propertyTypes.map((type, index) => (
                <option key={index} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>

          <button
            type="submit"
            className="btn btn--primary btn--full-width btn--lg"
            disabled={loading}
          >
            {loading ? "Sending..." : "Send"}
          </button>

          {status.message && (
            <div
              className={`form-status ${
                status.type === "success" ? "success" : "error"
              }`}
            >
              {status.message}
            </div>
          )}
        </form>

        {/* WhatsApp Contact */}
        <div className="whatsapp-contact">
          <button onClick={handleWhatsAppClick} className="whatsapp-btn">
            <div className="whatsapp-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.89 3.297"
                  fill="#25D366"
                />
              </svg>
            </div>
            <div className="whatsapp-text">
              <span className="whatsapp-label">Chat with our expert</span>
              <span className="whatsapp-number">(+91) 9999063322</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default StickyContactForm;
